import en_US from './locale/en_US.js'
import zh_CN from './locale/zh_CN.js'
const locales = {
    'en-US': en_US,
    'zh-CN': zh_CN,
};
 
export default locales